module.exports = __webpack_public_path__ + "img/close-white.8f254cb9.svg";